import React from "react";
import RootDashboardView from "./pages/RootDashboardView";

export default function DashboardSuperAdmin() {
  return <RootDashboardView />;
}
